import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, ArrowRight } from 'lucide-react';

/**
 * Soft upgrade nudge that appears when user is approaching (but not at) their limit
 * Shows at n-1 of limit (e.g., 4/5 habits)
 */
const SoftUpgradeNudge = ({ 
  current, 
  limit, 
  itemType = 'items', // 'habits', 'tasks', 'goals', 'events'
  colors,
  onUpgradeClick
}) => {
  // Only show if approaching limit (1 away) and not already unlimited
  if (limit === Infinity || current < limit - 1 || current >= limit) {
    return null;
  }

  const messages = {
    habits: {
      title: "You're building momentum!",
      subtitle: `${current}/${limit} habits tracked. Upgrade for unlimited habits + Google Calendar sync.`
    },
    tasks: {
      title: "Task master in progress!",
      subtitle: `${current}/${limit} tasks. Upgrade for unlimited tasks + recurring tasks.`
    },
    goals: {
      title: "Goal crusher!",
      subtitle: `${current}/${limit} goals. Upgrade for unlimited goals + milestones.`
    },
    events: {
      title: "Calendar filling up!",
      subtitle: `${current}/${limit} events. Upgrade for unlimited events + Google Calendar sync.`
    },
    items: {
      title: "Almost at the limit!",
      subtitle: `${current}/${limit} items. Upgrade for unlimited access.`
    }
  };

  const message = messages[itemType] || messages.items;

  return (
    <div 
      className="mb-4 p-4 rounded-md flex items-center justify-between gap-4 animate-fade-in"
      style={{ 
        backgroundColor: `${colors.accent}10`,
        border: `1px solid ${colors.accent}30`
      }}
    >
      <div className="flex items-center gap-3">
        <div 
          className="w-10 h-10 rounded-full flex items-center justify-center"
          style={{ backgroundColor: `${colors.accent}20` }}
        >
          <Sparkles size={20} style={{ color: colors.accent }} />
        </div>
        <div>
          <p className="text-sm font-medium" style={{ color: colors.textPrimary }}>
            {message.title}
          </p>
          <p className="text-xs" style={{ color: colors.textSecondary }}>
            {message.subtitle}
          </p>
        </div>
      </div>
      
      {onUpgradeClick ? (
        <button
          onClick={onUpgradeClick}
          className="flex items-center gap-1 px-4 py-2 rounded-lg text-xs font-medium transition-all "
          style={{ backgroundColor: colors.accent, color: colors.onAccent }}
        >
          Upgrade
          <ArrowRight size={14} />
        </button>
      ) : (
        <Link
          to="/upgrade"
          className="flex items-center gap-1 px-4 py-2 rounded-lg text-xs font-medium transition-all "
          style={{ backgroundColor: colors.accent, color: colors.onAccent }}
        >
          Upgrade
          <ArrowRight size={14} />
        </Link>
      )}
    </div>
  );
};

export default SoftUpgradeNudge;
